import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import { GestionFilter } from "./Components/GestionFilters";
import RowData from "./Actuaciones/RowData";
import GestionTable from "../../../components/FilterTable/GestionTable";
import { v4 as uuidv4 } from "uuid";
// import icon from "../../../assets/static/images/secciones/gestionlegal.png";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import EditActuacion from "./Actuaciones/EditActuacion/EditActuacion";
import AlertInfo from "../../../components/AlertInfo";
import EditConvenio from "../Convenios/Components/EditConvenio";
import { useUser } from "../../../hooks/useUser";
// import LoadingModal from "../../../components/LoadingModal/LoadingModal";

const GestionLegal = ({ action, data, type }) => {
  const user = useUser();
  // const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(true);
  const [filters, setFilters] = useState({});
  const [showTable, setShowTable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showConvenio, setShowConvenio] = useState(false);
  const [actuacion, setActuacion] = useState("");
  const [convenio, setConvenio] = useState("");
  // const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(location.search);
  const nombre = params.get("nombre");
  const grupo = params.get("grupo");
  const historico = params.get("historico");
  const extrajudicial = params.get("extrajudicial");
  const abogado = params.get("abogado");
  const imponible = params.get("imponible");
  const recurso = params.get("recurso");

  useEffect(() => {
    const getData = async () => {
      setFilters({
        ...filters,
        abogado: abogado || user.abogado
      });
  
      if (type === "comercios") {
        action({ contrib: nombre, abogado: abogado || user.abogado });        
      } else {
        action({ nombre, imponible, recurso, abogado: abogado || user.abogado });        
      }
      
      setShowFilter(false);
      setShowTable(true);  
    };

    getData();
  }, [nombre, imponible]);

  const handleModalClose = () => setShowModal(false);

  const handleConvenio = (e) => {
    setConvenio(e);
    setShowConvenio(true);
  };

  const handleClose = () => {
    setConvenio("");
    setShowConvenio(false);
  };

  const formatData = (dataTable) => {
    if (dataTable && dataTable?.length) {
      if (type === "comercios") {
        return dataTable.map((e, i) => {
          return {
            ...e,
            id: `${type}_${i}`,
            uuid: uuidv4(),
            imponible: e.NRO_COMERCIO,
            codexterno: user.abogado
          };
        });
      }
      else {
        return dataTable.map((e, i) => {
          const {
            CALLE, NRO, PISO, DEPT,
            PAR_PROVINCIAL,
            CIRCUNS,
            SECCION,
            CHACRA_NRO,
            CHACRA_LET,
            QUINTA_NRO,
            QUINTA_LET,
            FRACCION_NRO,
            FRACCION_LET,
            MANZANA_NRO,
            MANZANA_LET,
            PARCELA_NRO,
            PARCELA_LET,
            UNI_FUNCIONAL,

            RECURSO,
            NRO_INMUEBLE
          } = e;

          return {
            id: i,
            uuid: uuidv4(),
            ...e,
            DOMICILIO: e.DOMICILIO || `${CALLE || ""} ${NRO || ""} ${PISO ? ` - PISO: ${PISO}` : ""} ${DEPT ? `DEPT: ${DEPT}` : ""}`,
            NOMENCLATURA: e.NOMENCLATURA || `
            ${CIRCUNS ? `CIRCUNS: ${CIRCUNS}` : ""} ${SECCION ? `- SECCION: ${SECCION}` : ""} ${CHACRA_NRO ? `- CHACRA_NRO: ${CHACRA_NRO}` : ""} ${CHACRA_LET ? `- CHACRA_LET: ${CHACRA_LET}` : ""}
            ${QUINTA_NRO ? `- QUINTA_NRO: ${QUINTA_NRO}` : ""} ${QUINTA_LET ? `- QUINTA_LET: ${QUINTA_LET}` : ""} ${FRACCION_NRO ? `- FRACCION_NRO: ${FRACCION_NRO}` : ""} ${FRACCION_LET ? `- FRACCION_LET: ${FRACCION_LET}` : ""}
            ${MANZANA_NRO ? `- MANZANA_NRO: ${MANZANA_NRO}` : ""} ${MANZANA_LET ? `- MANZANA_LET: ${MANZANA_LET}` : ""} ${PARCELA_NRO ? `- PARCELA_NRO: ${PARCELA_NRO}` : ""} ${PARCELA_LET ? `- PARCELA LET: ${PARCELA_LET}` : ""}
            ${UNI_FUNCIONAL ? `- SUBPARCELA: ${UNI_FUNCIONAL}` : ""}`,
            PARTIDA: e.PARTIDA || `${PAR_PROVINCIAL ? `PARTIDA: ${PAR_PROVINCIAL}` : ""}`,
            recurso: RECURSO,
            imponible: NRO_INMUEBLE,
            abogado: `${user.apellido} ${user.nombre} (${user.abogado})`,
            codexterno: user.abogado
          };
        });
      }
    } else {
      return [];
    }
  };

  function exportData(list) {
    let filename = `gestionlegal-${new Date().getTime()}.xlsx`;

    let dataList = [];
    if (list && list?.length) {
      dataList = list.map((e) => {
        return {
          "IMPONIBLE": e.imponible || e.NRO_INMUEBLE,
          "RECURSO": e.recurso || e.RECURSO,
          "CONTRIBUYENTE": e.apynom || e.APYNOM
        };
      });
    }
    let name = "Gestión legal";

    return {
      dataList,
      filename,
      name
    };
  }

  const reloadData = () => {
    // action(filters);
    window.location.reload();
  };

  return (
    <div className="section-container section-content">
      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )}
        </div>
      </div>
      <div className="section-filter">
        <GestionFilter showFilter={showFilter} setShowFilter={setShowFilter} action={action} setFilters={setFilters} filters={filters} setShowTable={setShowTable} type={type} abogadoFilter={abogado} />
      </div>

      {showTable ? (
        <div className="section-table">
          {data?.length && ((!historico || extrajudicial)) ? (
            <AlertInfo>
              <div className="d-flex align-items-center">
                Para generar nueva actuación puede marcar
                <div className="ant-table-selection mx-1"><input type="checkbox" className="ant-checkbox-input" value="" /><span className="ant-checkbox-inner"></span></div>
              </div>
            </AlertInfo>
          ) : null}

          <GestionTable
            dataList={formatData(data)}
            expandable
            selection
            RowData={RowData}
            filters={filters}
            setShowModal={setShowModal}
            setActuacion={setActuacion}
            handleConvenio={handleConvenio}
            reloadData={reloadData}
            type={type}
            grupo={grupo}
            historico={historico}
            extrajudicial={extrajudicial}
            abogado={abogado}
          />

          {type === "inmuebles" && (
            <div className="mt-3">
              <div style={{ maxWidth: 170 }}>
                <DescargarExcel data={exportData(data)} />
              </div>
            </div>
          )}
        </div>
      ) : null}

      {showModal ? (
        <EditActuacion show={showModal} handleClose={handleModalClose} actuacion={actuacion} action={action} filters={filters} />
      ) : null}
      {showConvenio ? (
        <EditConvenio show={showConvenio} handleClose={handleClose} convenioId={convenio?.id} convenio={convenio} />
      ) : null}

      {/* {loading ? <LoadingModal show={loading} loading={true} /> : null} */}
    </div>
  );
};

export default GestionLegal;